import { render, staticRenderFns } from "./RDCLifecycle.vue?vue&type=template&id=0bb515da"
import script from "./RDCLifecycle.vue?vue&type=script&lang=js"
export * from "./RDCLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports